
export type Noop = () => void


export type Observer<T> = {
  id: string
  next: (value: T, subscriberId?: string) => void
}

export type Subscription = {
  unsubscribe: Noop
}

export type CacheableSubject<T> = {
  getValue: () => T
  // notifyOthers: (params: { id: string, newValue: any }) => void
  subscribe: (value: Observer<T>) => Subscription
  // unSubscribeAll: Noop
} & Omit<Observer<T>, 'id'>



export function createCacheableSubject<T> (defaultValue: T, getValueOnSubscribe = false): CacheableSubject<T> {
  let isFlushing = false
  let itemsToFlush: Array<T> = []

  let observerList: Array<Observer<T>> = []
  let value = defaultValue

  const getValue = (): T => value

  // const notifyOthers = (params: { id: string, newValue: any }): void => {
  //   value = params.newValue
  //
  //   void Promise.resolve().then(() => {
  //     observerList.forEach((o) => {
  //       if (o.id !== params.id)
  //         o.next(value)
  //     })
  //   })
  // }


  const next = (newValue: T, subscriberId?: string): void => {
    value = newValue

    itemsToFlush.push(newValue)

    if (!isFlushing) {
      isFlushing = true
      void Promise.resolve().then(() => {
        observerList.forEach((o) => {
          if (o.id === subscriberId) return

          o.next(itemsToFlush as T)
        })
        itemsToFlush = []
        isFlushing = false
      })
    }
  }

  const subscribe = (observer: Observer<T>): Subscription => {
    // Push cached value on subscribe
    if (getValueOnSubscribe) observer.next(value)
    // Store the observer to be notified
    observerList.push(observer)

    return {
      unsubscribe: () => {
        observerList = observerList.filter(o => o !== observer)
      },
    }
  }

  // const unSubscribeAll = (): void => {
  //   observerList = []
  // }

  return {
    getValue,
    next,
    // notifyOthers,
    subscribe,
    // unSubscribeAll,
  }
}
